import React from "react"
function AuthLayout({ children }) {
  return <div>{children}</div>
}

export default AuthLayout
